import type { RASTER_COLORMAP_NAMES } from './Colors';
import { AreaEmissionsProducts } from './MapLayers';
import { Platforms } from './MapState';

export interface UrlViewState {
    latitude: number;
    longitude: number;
    // we use zoom.toFixed() to get the zoom passed to the url,
    // so it's a string, at least for now
    zoom: string;
}

/**
 * Types related to the URL querystring
 * Used in hooks/syncQueryString.tsx
 */
export enum UrlSelectionTypes {
    Target = 'target',
    Details = 'details'
}
export type CardUrlState = {
    'selected-lat': number;
    'selected-lng': number;
    'selection-type': UrlSelectionTypes;
    targets: string[];
} & {
    /**
     * any key: value pairs for information identifying specific selections
     * target-XX-date: string
     * target-XX-itemId: string stac item id
     * target-XX-collection: string stac collection id
     * target-XX-points: array of string plume_ids
     * adding | number keeps typescript happy, because lat & lng are numbers
     */
    [key: string]: string | number | string[];
};

export type BaseUrlState = {
    view?: UrlViewState;
    date?: string;
    platform?: Platforms;
    product?: AreaEmissionsProducts;
    'color-scale'?: RASTER_COLORMAP_NAMES;
};

export type UrlState = BaseUrlState & Partial<CardUrlState>;
